module.exports = __webpack_public_path__ + "img/霞洞上河贡园.3a81b6e8.png";